import React from "react";
import { makeStyles, Button, FormControl, OutlinedInput, InputAdornment, CircularProgress } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: "flex"
    },
    inputRoot: {
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0"
    },
    go: {
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0"
    }
}); });
/** A combined search input */
export var SearchField = function (_a) {
    var dataCy = _a["data-cy"], value = _a.value, onChange = _a.onChange, onClick = _a.onClick, loading = _a.loading, _b = _a.placeholder, placeholder = _b === void 0 ? "What are you looking for?" : _b;
    var classes = useStyles();
    // Note: label prop doesn't do the animation thing when combined with startAdornment
    // Hence placeholder used here.
    return (React.createElement("div", { className: classes.root },
        React.createElement(FormControl, { fullWidth: true, variant: "outlined" },
            React.createElement(OutlinedInput, { placeholder: placeholder, id: "standard-adornment-amount", value: value, onChange: onChange, 
                // labelWidth={172}
                className: classes.inputRoot, startAdornment: React.createElement(InputAdornment, { position: "start" },
                    React.createElement(SearchIcon, null)) })),
        React.createElement(Button, { variant: "contained", color: "primary", className: classes.go, onClick: onClick, disabled: loading }, loading ? React.createElement(CircularProgress, { color: "inherit", size: "1rem" }) : "Go")));
};
//# sourceMappingURL=SearchField.js.map